import script from "./team-resort-view.vue?vue&type=script&setup=true&lang=js"
export * from "./team-resort-view.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__